<div fxLayout="column" fxLayoutGap="10px" id="{{info.id}}" *ngFor="let info of infosNote$;">


  <!-- title -->
  <div>
    <span class="title-endorder-card boldest">{{info.name| capitalize}}&nbsp;&nbsp;&nbsp;</span>
    <span *ngIf="info.sale_methods[0].compulsory === 1" class="mat-subheading-1">{{"required"|translate}}</span>
  </div>

  <!-- is_numeric or not  && !info.is_phone -->
  <div class="form-field-endorder  full-w" [ngClass]="{'animErr errRequired' : error === info.id && !info.value}"
    *ngIf="!info.is_phone">

    <mat-form-field appearance="outline" fxFlex>

      <input matInput type="text" [(ngModel)]="info.value" placeholder="{{info.name | capitalize}}..."
        (change)="updateInfoNote()" angulartics2On="click" angularticsAction="writeInfoNote" angularticsCategory="order"
        *ngIf="info.is_numeric === 0" [disabled]='info.disabled'>


      <input matInput type="number" min="0" [(ngModel)]="info.value" placeholder="{{info.name | capitalize}}..."
        (change)="updateInfoNote()" angulartics2On="click" angularticsAction="writeInfoNote" angularticsCategory="order"
        *ngIf="info.is_numeric === 1" [disabled]='info.disabled'>


    </mat-form-field>

  </div>


  <!-- is_phone-->

  <div *ngIf="info.is_phone && filteredCountries" fxLayout="column">



    <div fxLayout="row" fxLayoutGap="10px">
      <!-- country -->
      <div class="form-field-endorder" fxFlex="30">

        <mat-form-field appearance="outline" class="full-w">
          <!-- <mat-select [(ngModel)]="info.country.id" (selectionChange)="doSomething($event,filteredCountries)" >

            <mat-select-trigger>

              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <img src="data:image/png;base64,{{info.country.flag}}" height="20">
                <span>{{info.country.name | uppercase}}</span>
              </div>
            </mat-select-trigger>
            (click)="setSelectedCountry(country,info)"


            <mat-option *ngFor="let country of filteredCountries" [value]="country.id"
             >
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <img src="data:image/png;base64,{{country.flag}}" height="25">
                <span>{{country.name | uppercase}}</span>
              </div>
            </mat-option>

          </mat-select> -->



          <mat-select [(ngModel)]="info.country_id" (selectionChange)="setSelectedCountry($event,info)">
            <mat-select-trigger>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <img *ngIf="info.flag" src="data:image/png;base64,{{info.flag}}"  class="h-8">
                <div *ngIf="!info.flag">
                  <mat-icon>outlined_flag</mat-icon>
                </div>
                <span>{{info.country_name| uppercase}}</span>
              </div>
            </mat-select-trigger>
            <mat-option *ngFor="let country of filteredCountries" [value]="country.id">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <img *ngIf="country.flag" src="data:image/png;base64,{{country.flag}}"  class="h-8">
                <div *ngIf="!country.flag">
                  <mat-icon>outlined_flag</mat-icon>
                </div>
                <span>{{country.name | uppercase}}</span>
              </div>
            </mat-option>
          </mat-select>

        </mat-form-field>

      </div>

      <!-- phone -->
      <div class="form-field-endorder form-nopadd full-w"
        [ngClass]="{'animErr errRequired' : error === info.id && !info.value && info.sale_methods[0].compulsory === 1 }">

        <mat-form-field appearance="outline" fxFlex
          [ngClass]="{'mat-form-field-invalid': phoneError && phoneError.id  === info.id}">
          <input matInput type="tel" min="0" [(ngModel)]="info.value" placeholder="{{info.name | capitalize}}..."
            (ngModelChange)="updateInfoNote(info.id)" angulartics2On="click" angularticsAction="writeInfoNote"
            angularticsCategory="order" [disabled]='info.disabled' pattern="[^a-zA-Z]{1,}">
        </mat-form-field>

      </div>

    </div>
    <!-- error -->
    <div fxLayout="row" fxLayoutAlign="end center " ngClass.xs="layout-padd-10-bottom ">

      <span *ngIf="phoneError && phoneError.id  === info.id"
        class="warn-ico mat-subheading-1">{{phoneError.message}}</span>
    </div>



  </div>



  <!-- 0475871902 -->

</div>
